import { render } from "./ChartComponent.vue?vue&type=template&id=ea22267a&scoped=true"
import script from "./ChartComponent.vue?vue&type=script&lang=js"
export * from "./ChartComponent.vue?vue&type=script&lang=js"

import "./ChartComponent.vue?vue&type=style&index=0&id=ea22267a&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea22267a"]])

export default __exports__